import React from "react";
import Layout from "../components/Layout/Layout";
import Slotmachine from "../containers/Slotmachine/Slotmachine";
import CoinFlip from "../containers/CoinFlip/CoinFlip";

export default [
  {
    path: "/",
    name: "",
    exact: true,
    layout: Layout,
    component: Slotmachine
  },
  {
    path: "/slot_machine",
    name: "slot",
    exact: true,
    layout: Layout,
    component: Slotmachine
  },
  {
    path: "/coin_flip",
    name: "coin",
    exact: true,
    layout: Layout,
    component: CoinFlip
  }
];
